import { UUID } from '../shared/UUID';

export interface IClientResponse {
  id?: UUID;
  name: string;
  spruce_powered: boolean;
}

export interface IClientData {
  id?: UUID;
  name: string;
  sprucePowered: boolean;
}

export const convertIClientResponseToIClientData = ({ spruce_powered, ...rest }: IClientResponse): IClientData => ({
  sprucePowered: spruce_powered,
  ...rest,
});

export const convertIClientDataToIClientResponse = ({ sprucePowered, ...rest }: IClientData): IClientResponse => ({
  spruce_powered: sprucePowered,
  ...rest,
});
